import { computed } from '@vue/composition-api'
import { useSettingStore } from '@ms/stores/setting.js'
import { storeToRefs } from 'pinia'
import {
  themeModeValueToNameMap,
  themeTypeValueToNameMap,
  isCurrentPageEnabledTheme
} from '@ms/utils/theme.js'
import { THEME_MODE, THEME_TYPE } from '@ms/config/theme'

/**
 * @typedef {import('./useThemeImageType').ThemeImageOptions} ThemeImageOptions
 */

/**
 * Get image based on current themeMode and themeType
 * @param {ThemeImageOptions} options 
 */
export const useThemeImage = (options) => {
  if (options == null) {
    throw new Error('options is required')
  }

  const settingStore = useSettingStore()
  const { themeMode, themeType, systemThemeMode } = storeToRefs(settingStore)

  const themeModeName = computed(() => {
    if (!isCurrentPageEnabledTheme.value) {
      return THEME_MODE.DARK.name
    }

    if (themeMode.value === THEME_MODE.SYSTEM.value) {
      return themeModeValueToNameMap.value.get(systemThemeMode.value)
    }

    return themeModeValueToNameMap.value.get(themeMode.value)
  })
  const themeTypeName = computed(() => {
    if (!isCurrentPageEnabledTheme.value) {
      return THEME_TYPE.DEFAULT.name
    }

    return themeTypeValueToNameMap.value.get(themeType.value)
  })

  const image = computed(() => {
    const currentThemeImage = options[themeModeName.value]?.[themeTypeName.value]
    if (currentThemeImage != null) {
      return currentThemeImage
    }

    const currentThemeModeDefaultImage = options[themeModeName.value]?.default
    if (currentThemeModeDefaultImage != null) {
      return currentThemeModeDefaultImage
    }

    return null
  })

  return image
}